import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "../../../libs/css/dataTable.css";
import Nulls from "../Nulls";
// import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { API_ROUTES } from "../../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/getToken";
import Swal from "sweetalert2";
import { apiFetch } from "../../../utils/apiFetch";
import { useLocation } from "react-router-dom";
import Spinner from "../../../Spinner/Spinner";

function MarketerReportTable(props) {
  const {
    companyName,
    setCompanyName,
    capitalizeWords,
    isLoading,
    setIsLoading,
    columns,
    dataList,
    setDataList,
    countPerPage,
    setPage,
    isFade,
    setIsFade,
    isAuthExpired,
    objectToFormData,
    setColumns,
  } = props;

  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  //Check location state first for companyId.
  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;



  // this is for marker coming from the  sidebar
  useEffect(() => {
    const storedCompanyData = localStorage.getItem("userVASData");

    if (storedCompanyData) {
      const parsedData = JSON.parse(storedCompanyData);
      const id = parsedData.responseDetails?.id;

      setCompanyId(id);
      // console.log("na me company id ooo", id);
    }
  }, []);

  // this is for the comapnat coming from sidebar and the rest
  useEffect(() => {
    if (rowData?.id && rowData?.companyName) {
      // Save company data to localStorage
      localStorage.setItem(
        "companyVASData",
        JSON.stringify({
          id: rowData.id,
          companyName: rowData.companyName,
        })
      );

      // Set states
      setCompanyId(rowData.id);
      setCompanyName(rowData.companyName);
    } else {
      try {
        const storedCompanyData = localStorage.getItem("companyVASData");

        if (storedCompanyData) {
          const { id, companyName } = JSON.parse(storedCompanyData);
          setCompanyId(id);
          setCompanyName(companyName);
        }
      } catch (error) {
        console.error("Error parsing companyVASData:", error);
      }
    }
  }, []);

  const getAllCompanyTotal = async () => {
    const token = getToken();
    if (!token) {
      console.error("No token found");
      return;
    }

    if (!companyId) {
      // console.error("Company ID is missing.");
      return;
    }

    setLoading(true);

    try {
      const url = `${API_ROUTES.GET_ALL_COMPANY_MARKETER}/${encodeURIComponent(
        companyId
      )}`;
      const response = await apiFetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      // console.log("this is markete response", response);
      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      if (Array.isArray(responseJSON)) {
        const sortedData = responseJSON;
        // console.log("this is the sorted data", sortedData);
        // get total row and save to state
        setTotalRows(sortedData.length);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCompanyTotal();
  }, [companyId]);

  useEffect(() => {
    // console.log("Updated total number:", totalRows);
  }, [totalRows]);

  const getAllCompany = async (PageNumber) => {
    const token = getToken();
    if (!token) {
      console.error("No token found");
      return;
    }

    if (!companyId) {
      console.error("Company ID is missing.");
      return;
    }

    setLoading(true);

    try {
      const url = `${API_ROUTES.GET_ALL_COMPANY_MARKETER}/${encodeURIComponent(
        companyId
      )}?PageSize=${pageSize}&PageNumber=${PageNumber}`;

      const response = await apiFetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      // console.log(
      //   "response getAllCompany===================getAllCompany===========-",
      //   response
      // );
      // console.log("this is markete response", response);
      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      if (Array.isArray(responseJSON)) {
        const sortedData = responseJSON
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setDataList(sortedData);
        // setTotalRows(responseJSON.length);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setDataList([]);
    } finally {
      setLoading(false);
    }
  };

  //Call the API once companyId is set.
  useEffect(() => {
    if (companyId) {
      getAllCompany(pageNumber);
    }
  }, [companyId, pageNumber]);

  const handlePageChange = (page) => {
    setPageNumber(page);
    getAllCompanyTotal();
  };

  const handlePerPageChange = (pageSize) => {
    setPageSize(pageSize);
    setPageNumber(1); // Reset to page 1 when changing rows per page
  };

  const ExpandedComponent = ({ data }) => (
    <div className="text-left th_data mt-3 pb-4">
      <div>
        <font>Actions: &nbsp;&nbsp; </font>
        <span style={{ textTransform: "uppercase" }}>
          <Link
            to="/marketer/edit"
            state={{ rowData: data }}
            onClick={() => localStorage.setItem("companyName", companyName)}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6a73fa",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="mx-2"
          >
            Update Marketer
          </Link>
        </span>
        <span style={{ textTransform: "uppercase" }}>
          <Link
            to="/marketer/delete"
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "red",
              border: 'none',
              color: "white",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="mx-1"
          >
            Delete Marketer
          </Link>
        </span>
        <span style={{ textTransform: "uppercase" }}>
          <Link
            to="/marketer/details"
            state={{ rowData: data }}
            onClick={() => localStorage.setItem("companyName", companyName)}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6a73fa",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="mx-1"
          >
            View More
          </Link>
        </span>
        <span style={{ textTransform: "uppercase" }}>
          <Link
            to="/dashboard/marketer"
            state={{ rowData: data }}
            style={{
              fontSize: "13px",
              textTransform: "none",
              backgroundColor: "#6e73b3",
              border: 'none',
              color: "#fff",
              padding: "8px 10px",
              borderRadius: '6px'
            }}
            className="mx-1"
          >
            View Analytics
          </Link>
        </span>
      </div>
    </div>
  );

  return (
    <div className="App">
      <div style={{ opacity: isFade ? "0.3" : 1 }} className="mt-0">
        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <DataTable
            className="services_datatable display text-nowrap"
            title=""
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            columns={columns}
            data={dataList}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={pageSize}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            progressPending={loading}
            paginationDefaultPage={pageNumber}
            // onChangePage={(pageNumber) => setPageNumber(pageNumber)}
            // onChangeRowsPerPage={handlePageChange}
            onChangeRowsPerPage={handlePerPageChange}
            // onChangePage={handlePageChange}
            onChangePage={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}

export default MarketerReportTable;
